import { COMPANY_MANAGER_PROFILES, hasCurrentProfile, hasPlugin } from "app/utils/appHelpers";

// Quién ve Descargas y Reportes. El backend exige lo mismo; esto solo muestra u oculta las opciones.
export const DOWNLOAD_PROFILES = COMPANY_MANAGER_PROFILES;
export const SHIFT_EDITOR_PROFILES = COMPANY_MANAGER_PROFILES;

export const canExportData = (user) => hasPlugin(user, "data-export") && hasCurrentProfile(user, DOWNLOAD_PROFILES);
export const canUseReports = (user) => hasPlugin(user, "reports") && hasCurrentProfile(user, DOWNLOAD_PROFILES);
export const canUseDownloads = (user) => canExportData(user) || canUseReports(user);
export const canEditShifts = (user) => hasPlugin(user, "reports") && hasCurrentProfile(user, SHIFT_EDITOR_PROFILES);
